import { getSEODescription } from "@/utils/sanityUtils";

export interface ArticleDTO {
  _id: string;
  title: string;
  slug: string;
  date: string;
  image: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body?: any[];
}

export class ArticleModel {
  readonly _id: string;
  readonly title: string;
  readonly slug: string;
  readonly date: Date;
  readonly image: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly body?: any[];

  constructor(articleDTO: ArticleDTO) {
    this._id = articleDTO._id;
    this.title = articleDTO.title;
    this.slug = articleDTO.slug;
    this.date = new Date(articleDTO.date);
    this.image = articleDTO.image;
    this.body = articleDTO.body;
  }

  toJSON() {
    return { ...this };
  }

  getSEODescription() {
    if (this.body) {
      return getSEODescription(this.body);
    } else {
      return "";
    }
  }
}
